import {styled} from "@mui/material/styles";
import {Box} from "@mui/material";

export const InputsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 600px;
  padding: 10px 15px;
  border-radius: 8px;
  border-color: #e0e0e0;
  box-shadow: 0 1px 2px 0 rgb(60 64 67/ 30%), 0 2px 6px 2px rgb(60 64 67/ 15%);
  margin: auto;
  min-height: 30px;
`
